"use client";

import { c as _c } from "react/compiler-runtime";
import { SearchDialog } from "@features/search";
import { StarIcon } from "@heroicons/react/24/outline";
import { Bars3Icon, ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, Button, Carousel, CarouselApi, CarouselContent, CarouselItem, cn, Dialog, DialogContent, DialogTitle, DialogTrigger, Popover, PopoverContent, PopoverTrigger, SearchInput, Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@saridana-core/react-ui-kit";
import { getLinksFromNavData, NavLink } from "@shared/lib";
import { LeafIcon, WhatsappIcon } from "@shared/ui/custom-icon";
import { transformQueryParamsWithoutLocale } from "@shared/utils";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
function MenuItemContent(t0) {
  const $ = _c(21);
  const {
    nav,
    onClick
  } = t0;
  const [api, setApi] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  let t1;
  let t2;
  if ($[0] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      setCurrentIndex(api.selectedScrollSnap());
      api.on("select", () => {
        setCurrentIndex(api.selectedScrollSnap());
      });
    };
    t2 = [api];
    $[0] = api;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = nav.size === "sm" ? "col-span-12" : "col-span-12 xl:py-5 xl:px-4";
  const t4 = nav.size === "md" && nav.promotion && nav.promotion.length > 0 ? "xl:col-span-8" : "";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = cn("grid grid-cols-1 overflow-hidden", t3, t4);
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== nav.list || $[7] !== nav.size || $[8] !== onClick) {
    t6 = nav.list?.map((listItem, i) => <div key={listItem.text + "-" + i} className={cn("w-full py-2 px-4 sm:px-6 xl:px-3 items-start flex gap-4 cursor-pointer text-gray-900 relative overflow-hidden rounded-lg", nav.size === "sm" ? "hover:bg-[#F6FAFD]" : "hover:text-primary")}>{listItem.icon?.data?.attributes && <div className="w-12 h-12 bg-primary-50 inline-flex rounded-md items-center justify-center text-center"><Image src={listItem.icon?.data?.attributes?.url as string} alt={listItem.icon?.data?.attributes?.alternativeText || listItem.icon?.data?.attributes?.name || "Nav icon"} width={listItem.icon?.data?.attributes?.width} height={listItem.icon?.data?.attributes?.height} className="size-6" /></div>}<div className="flex-1"><Link href={listItem.href} target={listItem.target || "_self"} onClick={() => onClick()} className="font-semibold text-base sm:text-lg block">{listItem.text}</Link>{listItem.description && <div className="text-base text-gray-600 mt-1">{listItem.description}</div>}{listItem.subLinks && listItem.subLinks.length > 0 ? <div className="flex flex-col w-full gap-2 mt-3">{listItem.subLinks.map((subLink, subLinkIndex) => <Link className="group bg-gray-50 rounded-md px-3 py-2 flex items-start gap-2 hover:text-primary text-gray-400 hover:bg-primary-50" key={subLink.href + "-" + subLink.text + "-" + subLinkIndex} href={subLink.href} target={subLink.target || "_self"} onClick={() => onClick()}>{subLink?.icon?.data?.attributes?.url && <Image src={subLink?.icon?.data?.attributes?.url as string} alt={subLink?.icon?.data?.attributes?.alternativeText || subLink?.icon?.data?.attributes?.name || "Nav icon"} width={subLink?.icon?.data?.attributes?.width} height={subLink?.icon?.data?.attributes?.height} className={cn("size-[18px] mt-1 font-bold stroke-[2.5px] transform-all duration-100 grayscale group-hover:grayscale-0")} />}<div className="flex-1"><span className="font-medium text-gray-900">{subLink.text}</span>{subLink.description && <><span className="text-gray-900 mx-1">•</span><span className="text-gray-900 font-normal">{subLink.description}</span></>}</div></Link>)}</div> : null}</div>{!listItem.subLinks || listItem.subLinks && listItem.subLinks.length <= 0 ? <Link href={listItem.href} target={listItem.target || "_self"} onClick={() => onClick()} className="absolute top-0 left-0 w-full h-full" /> : null}</div>);
    $[6] = nav.list;
    $[7] = nav.size;
    $[8] = onClick;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== api || $[14] !== currentIndex || $[15] !== nav.promotion || $[16] !== onClick) {
    t8 = nav.promotion && nav.promotion.length > 0 ? <div className="bg-[#F6FAFD] mt-4 sm:mt-6 xl:mt-0 py-7 sm:py-8 xl:py-7 px-4 sm:px-6 xl:px-9 col-span-12 xl:col-span-4 order-1 sm:order-2"><Carousel opts={{
        align: "start",
        loop: true
      }} setApi={setApi} plugins={[{
        plugin: "autoplay",
        options: {
          active: true,
          delay: 5000
        }
      }]}><CarouselContent>{nav.promotion.map((promotion, i_0) => <CarouselItem key={"promotion-" + promotion.target + "-" + i_0} className="basis-[100%] sm:basis-[50%] md:basis-[100%]"><h4 className="text-primary-700 uppercase font-bold">{promotion.title}</h4>{promotion.banner && <Image src={promotion.banner?.data?.attributes?.url} alt={promotion.banner?.data?.attributes?.alternativeText || promotion.banner?.data?.attributes?.name} width={promotion.banner?.data?.attributes?.width} height={promotion.banner?.data?.attributes?.height || 175} className="w-full h-auto object-cover rounded-md mt-3 max-h-[175px]" />}{(promotion.subtitle || promotion.description) && <div className="mt-5 flex flex-col gap-1 w-full">{promotion.subtitle && <div><Link href={promotion.href || "/"} target={promotion.target || "_self"} className="inline-flex items-center gap-1 text-gray-900 hover:text-primary text-lg font-semibold" onClick={() => onClick()}>{promotion.subtitle}<ChevronRightIcon className="size-4" /></Link></div>}{promotion.description && <div className="text-base text-gray-900">{promotion.description}</div>}</div>}</CarouselItem>)}</CarouselContent></Carousel>{nav.promotion && nav.promotion.length > 1 && <div className={cn("mt-[18px] flex items-center justify-start text-left gap-1.5")}>{nav.promotion.map((_, index) => <a key={"promotion-slide-indicator-" + index} className={cn("inline-block rounded-full size-[10px] cursor-pointer", index === currentIndex ? "bg-primary-500" : "bg-gray-400")} onClick={() => api?.scrollTo(index)}> </a>)}</div>}</div> : null;
    $[13] = api;
    $[14] = currentIndex;
    $[15] = nav.promotion;
    $[16] = onClick;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="grid grid-cols-12 items-stretch">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
export function Header() {
  const $ = _c(62);
  const clientConfig = useClientConfig();
  const [keyword] = useState("");
  const logo = clientConfig?.layoutSettings?.attributes.header?.logo?.data?.attributes;
  const whatsappManager = clientConfig?.layoutSettings?.attributes?.features?.whatsappManager;
  const headerNavigationItems = clientConfig?.layoutSettings?.attributes?.headerNavigation || [];
  const links = getLinksFromNavData(headerNavigationItems);
  const pathname = usePathname();
  const [dropdownContext, setDropdownContext] = useState(null);
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (open, nav) => {
      if (open) {
        setDropdownContext(nav.text);
      } else {
        setDropdownContext(null);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleToggleDropdown = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = open_0 => {
      setIsSheetOpen(open_0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleToggleSheet = t1;
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  let t2;
  if ($[2] !== isSearchOpen || $[3] !== setIsSearchOpen) {
    t2 = () => {
      setIsSearchOpen(!isSearchOpen);
    };
    $[2] = isSearchOpen;
    $[3] = setIsSearchOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleToggleSearch = t2;
  const router = useRouter();
  let t3;
  if ($[5] !== dropdownContext || $[6] !== pathname) {
    t3 = (nav_0, i) => {
      if (nav_0.list) {
        if (nav_0.size === "sm") {
          return <Popover key={nav_0.text + "-" + i} defaultOpen={dropdownContext === nav_0.text} open={dropdownContext === nav_0.text} onOpenChange={open_1 => handleToggleDropdown(open_1, nav_0)}><PopoverTrigger asChild={true}><Button variant="ghost" className={"font-semibold text-gray-700 rounded-xl text-lg hover:bg-primary-50 " + (dropdownContext === nav_0.text ? "bg-primary-50" : "")}>{nav_0.text}{dropdownContext === nav_0.text ? <ChevronUpIcon className="w-4 h-4" /> : <ChevronDownIcon className="w-4 h-4" />}</Button></PopoverTrigger><PopoverContent className={cn("p-0 mt-2 w-[100vw] max-h-[80vh] rounded-xl overflow-x-hidden overflow-y-auto md:w-[40vw] max-w-[200px]", nav_0.size === "sm" ? "lg:p-1" : "lg:px-4 lg:py-5")} align="start"><MenuItemContent nav={nav_0} onClick={() => handleToggleDropdown(false, nav_0)} /></PopoverContent></Popover>;
        }
        return <Dialog key={nav_0.text + "-" + i} defaultOpen={dropdownContext === nav_0.text} open={dropdownContext === nav_0.text} onOpenChange={open_2 => handleToggleDropdown(open_2, nav_0)}><DialogTrigger asChild={true}><Button variant="ghost" className={"font-semibold text-gray-700 rounded-xl text-lg hover:bg-primary-50 " + (dropdownContext === nav_0.text ? "bg-primary-50" : "")}>{nav_0.text}{dropdownContext === nav_0.text ? <ChevronUpIcon className="w-4 h-4" /> : <ChevronDownIcon className="w-4 h-4" />}</Button></DialogTrigger><DialogContent className={cn("p-0 border border-gray-200 !rounded-xl max-w-[1200px] mt-[77px] overflow-hidden", nav_0.promotion && nav_0.promotion.length > 0 ? "lg:w-[80vw]" : "lg:w-[60vw]")} hideCloseButton={true} mainBodyScrollable={true} overlayClassName="flex justify-center items-start bg-transparent"><DialogTitle className="hidden" /><MenuItemContent nav={nav_0} onClick={() => handleToggleDropdown(false, nav_0)} /></DialogContent></Dialog>;
      }
      return <Button variant="ghost" className="rounded-xl hover:bg-primary-50" asChild={true} key={nav_0.text + "-" + i}><Link href={nav_0.href} aria-current="page" className={"inline-flex items-center text-lg font-semibold whitespace-nowrap" + (nav_0.href === pathname ? " text-primary-600" : " text-gray-700")}>{nav_0.text}</Link></Button>;
    };
    $[5] = dropdownContext;
    $[6] = pathname;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getNavLink = t3;
  let t4;
  if ($[8] !== logo) {
    t4 = logo && <div className="flex shrink-0 items-center"><Link href="/"><Image src={logo.url} alt={logo.name} className="w-[166px] h-[38px] object-contain" width={logo.width || 166} height={logo.height || 38} /></Link></div>;
    $[8] = logo;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== getNavLink) {
    t5 = (nav_1, i_0) => getNavLink(nav_1, i_0);
    $[10] = getNavLink;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MagnifyingGlassIcon className="size-6" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handleToggleSearch) {
    t7 = <Button variant="ghost" size="lg" className="px-4 hidden xl:inline-block xl:mr-5" onClick={handleToggleSearch}>{t6}</Button>;
    $[13] = handleToggleSearch;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== whatsappManager) {
    t8 = whatsappManager && <div className="hidden sm:block"><Button asChild={true} className="font-semibold rounded-xl px-6" size="lg" variant="default"><Link href={whatsappManager.link} target="_blank"><WhatsappIcon className="w-5 h-5 text-white" />{whatsappManager.text || "Buka Rekening"}</Link></Button></div>;
    $[15] = whatsappManager;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = "-mr-2 flex items-center xl:hidden";
  const T0 = Sheet;
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SheetTrigger asChild={true}><Button variant="ghost"><span className="sr-only">Open main menu</span><Bars3Icon aria-hidden="true" className="block size-6 group-data-[open]:hidden" /><XMarkIcon aria-hidden="true" className="hidden size-6 group-data-[open]:block" /></Button></SheetTrigger>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const T1 = SheetContent;
  const t11 = "w-full sm:max-w-full md:max-w-xl overflow-y-auto !transition-none !animate-none";
  const t12 = "top-8 right-4";
  const t13 = "w-7 h-7";
  let t14;
  if ($[18] !== logo) {
    t14 = logo && <div className="flex shrink-0 items-center -ml-[9px] mt-0.5"><Link href="/"><Image src={logo.url} alt={logo.name} className="w-[166px] h-[38px] object-contain" width={logo.width || 166} height={logo.height || 38} /></Link></div>;
    $[18] = logo;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = <SheetHeader><SheetTitle>{t14}</SheetTitle></SheetHeader>;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = "-mx-6";
  const t17 = "mt-6";
  let t18;
  if ($[22] !== handleToggleSheet) {
    t18 = (nav_2, i_1) => nav_2.list ? <Accordion key={nav_2.text + "-" + i_1} collapsible={true} type="single" className="w-full"><AccordionItem value={nav_2.text + "-" + i_1} className="border-b border-gray-100 text-left"><AccordionTrigger className="px-4 sm:px-6 py-5 text-lg md:text-xl font-medium text-left hover:bg-[#F6FAFD] text-gray-900 hover:text-primary hover:opacity-100">{nav_2.text}</AccordionTrigger><AccordionContent className={cn("pb-0", nav_2.size === "sm" ? "px-3" : "px-0", "text-base md:text-lg")}><MenuItemContent nav={nav_2} onClick={() => handleToggleSheet(false)} /></AccordionContent></AccordionItem></Accordion> : <SheetClose asChild={true} key={nav_2.href + "-" + i_1}><Link href={nav_2.href} className={cn("block px-4 sm:px-6 py-5 text-lg md:text-xl font-medium text-left hover:bg-[#F6FAFD] text-gray-900 hover:text-primary border-b border-gray-100")}>{nav_2.text}</Link></SheetClose>;
    $[22] = handleToggleSheet;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  const t19 = links.map(t18);
  let t20;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="absolute inline-flex items-center justify-center h-full px-4"><MagnifyingGlassIcon className="size-6" /></div>;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== keyword) {
    t21 = <SearchInput readOnly={true} value={keyword} appendChild={t20} buttonClassName="hidden" inputClassName="pl-14 rounded-xl py-7 relative font-medium text-lg border-gray-200 pointer-events-none" placeholder="Cari sesuatu tentang Saridana" />;
    $[25] = keyword;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== handleToggleSearch) {
    t22 = <SheetClose asChild={true}><div className="absolute top-0 left-0 w-full h-full z-20 cursor-pointer" onClick={handleToggleSearch}> </div></SheetClose>;
    $[27] = handleToggleSearch;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== t21 || $[30] !== t22) {
    t23 = <div className="bg-white border-y border-gray-100 py-7 sm:py-8 px-4 sm:px-6 relative">{t21}{t22}</div>;
    $[29] = t21;
    $[30] = t22;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t19 || $[33] !== t23) {
    t24 = <div className={t17}>{t19}{t23}</div>;
    $[32] = t19;
    $[33] = t23;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] !== whatsappManager) {
    t25 = whatsappManager && <div className="mt-10 px-4"><SheetClose asChild={true}><Button asChild={true} className="font-semibold rounded-xl px-6 w-full" size="lg" variant="default"><Link href={whatsappManager.link} target="_blank"><WhatsappIcon className="w-5 h-5 text-white" />{whatsappManager.text || "Buka Rekening"}</Link></Button></SheetClose></div>;
    $[35] = whatsappManager;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] !== t24 || $[38] !== t25) {
    t26 = <div className={t16}>{t24}{t25}</div>;
    $[37] = t24;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  const t27 = clientConfig?.layoutSettings?.attributes?.footer?.brandInfo;
  let t28;
  if ($[40] !== t27) {
    t28 = <div className="sticky top-[100%] left-0 bg-white border-t border-gray-100 pt-6 sm:pt-7 pb-2 mt-10 sm:mt-14 text-sm sm:text-base text-gray-700">{t27}</div>;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== T1 || $[43] !== t15 || $[44] !== t26 || $[45] !== t28) {
    t29 = <T1 className={t11} closeClassName={t12} closeIconClassName={t13}>{t15}{t26}{t28}</T1>;
    $[42] = T1;
    $[43] = t15;
    $[44] = t26;
    $[45] = t28;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] !== T0 || $[48] !== handleToggleSheet || $[49] !== isSheetOpen || $[50] !== t10 || $[51] !== t29) {
    t30 = <div className={t9}><T0 open={isSheetOpen} onOpenChange={handleToggleSheet}>{t10}{t29}</T0></div>;
    $[47] = T0;
    $[48] = handleToggleSheet;
    $[49] = isSheetOpen;
    $[50] = t10;
    $[51] = t29;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== setIsSearchOpen) {
    t31 = open_3 => setIsSearchOpen(open_3);
    $[53] = setIsSearchOpen;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== router || $[56] !== setIsSearchOpen) {
    t32 = keyword_0 => {
      router.push(transformQueryParamsWithoutLocale("/search", {
        keyword: keyword_0
      }));
      setIsSearchOpen(false);
    };
    $[55] = router;
    $[56] = setIsSearchOpen;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] !== isSearchOpen || $[59] !== t31 || $[60] !== t32) {
    t33 = <SearchDialog open={isSearchOpen} onOpenChange={t31} onMoreClick={t32} />;
    $[58] = isSearchOpen;
    $[59] = t31;
    $[60] = t32;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  return <header><nav className="bg-white z-50 fixed w-full top-0 left-0"><div className="px-4 sm:px-6 xl:px-[60px]"><div className="flex h-[90px] justify-between items-center"><div className="flex w-full">{t4}<div className="hidden sm:-my-px ml-2 xl:ml-14 xl:flex xl:gap-2 justify-center w-full">{links.map(t5)}</div></div>{t7}{t8}{t30}</div></div></nav>{t33}</header>;
}